type Value = any;

export const convertDataTypeBoolean = <Y, N>(
  value: Value,
  positive: Y,
  negative: N
): Y | N => {
  let isPositive = false;

  if (typeof value === "string") {
    isPositive = value.toLowerCase() === "true";
  } else if (typeof value === "boolean") {
    isPositive = value;
  } else {
    isPositive = false;
  }

  return isPositive ? positive : negative;
};

export const convertDataTypeBooleanToBoolean = (value: Value): boolean => {
  return convertDataTypeBoolean(value, true, false);
};

export const convertDataTypeBooleanToString = (value: Value): string => {
  return convertDataTypeBoolean(value, "true", "false");
};
